import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../pages/Home.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
  {
    path: '/unternehmen/:id',
    name: 'Details',
    component: () => import(/* webpackChunkName: "about" */ '../pages/Detail.vue'),
  },
  {
    path: '/profile',
    name: 'Profil',
    component: () => import(/* webpackChunkName: "profile" */ '../pages/Profile.vue'),
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import(/* webpackChunkName: "profile" */ '../pages/Register.vue'),
  },
  {
    path: '/admin',
    name: 'Admin',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "admin" */ '../pages/Admin/Admin.vue'),
    children: [
      {
        path: '',
        component: () => import(/* webpackChunkName: "admin" */ '../pages/Admin/AdminUnternehmen.vue'),
      },
      {
        path: 'branchen',
        component: () => import(/* webpackChunkName: "admin" */ '../pages/Admin/AdminBranchen.vue'),
      },
      {
        path: 'unternehmen',
        component: () => import(/* webpackChunkName: "admin" */ '../pages/Admin/AdminUnternehmen.vue'),
      },
      {
        path: 'unternehmen/:id',
        name: 'unternehmensadmin',
        component: () => import(/* webpackChunkName: "admin" */ '../pages/Admin/AdminUnternehmenProfile.vue'),
      },
      {
        path: 'user',
        component: () => import(/* webpackChunkName: "admin" */ '../pages/Admin/AdminUser.vue'),
      },
      {
        path: 'user/:id',
        component: () => import(/* webpackChunkName: "admin" */ '../pages/Admin/AdminUserProfile.vue'),
      },
      {
        path: 'export',
        component: () => import(/* webpackChunkName: "admin" */ '../pages/Admin/AdminExport.vue'),
      },
    ],
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
});

router.afterEach((to, from) => {
  /* eslint-disable */
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'Virtual Page View',
    page_path: document.location.href.match(/https?:\/\/.*?(\/.*)/)[1],
  });
  /* eslint-enable */
});

export default router;
